export default __webpack_public_path__ + "static/media/DK.df5e44c8.svg";